import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import { AdminPolicyLetter } from "api/memberPortal/policies/policies.types";
import ActionsCell from "components/MUI/DataGrid/Cells/Actions/Actions.cell";
import IconMenuItem from "components/MUI/DataGrid/Cells/Actions/IconMenuItem";

interface PolicyLettersActionsCellProps {
  policy: AdminPolicyLetter;
  onEdit: () => void;
  onDelete: () => void;
}

const PolicyLettersActionsCell = ({
  policy,
  onEdit,
  onDelete,
}: PolicyLettersActionsCellProps) => {
  return (
    <ActionsCell id={`policy-${policy.policy_id}`}>
      <IconMenuItem Icon={EditIcon} label="Edit/View" onClick={onEdit} />
      <IconMenuItem Icon={DeleteIcon} label="Delete" onClick={onDelete} />
    </ActionsCell>
  );
};

export default PolicyLettersActionsCell;
